import { FC, ReactNode } from 'react';

export interface RowProps {
  children: ReactNode;
}

export const Row: FC<RowProps> = ({ children }) => <tr data-e2e="selected-underlying-item">{children}</tr>;
